import React from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface TipsPreferencesProps {
  acceptTips: boolean;
  onAcceptTipsChange: (checked: boolean) => void;
}

const TipsPreferences: React.FC<TipsPreferencesProps> = ({
  acceptTips,
  onAcceptTipsChange,
}) => {
  return (
    <div className="flex items-center space-x-2">
      <Switch
        id="accept_tips"
        checked={acceptTips}
        onCheckedChange={onAcceptTipsChange}
      />
      <Label htmlFor="accept_tips">Accept Tips</Label>
    </div>
  );
};

export default TipsPreferences;